import { FC } from "react";
import {
  Card,
  CardContent,
  CardHeader,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { useSelectedChallengeContext } from "@context/SelectedChallengeContext";
import { Bolt, Start } from "@mui/icons-material";

const InterruptingChallengeSelector: FC = () => {
  const {
    teamInterruptedGame,
    setTeamInterruptedGame,
    challenge: { team },
  } = useSelectedChallengeContext();

  return (
    <Card
      variant="elevation"
      elevation={5}
      sx={{
        flexDirection: "column",
        width: "350px",
        opacity: team === "referee" ? 0.6 : 1,
        display: "flex",
      }}
    >
      <CardHeader
        title={"Zeitraum der Beantragung"}
        titleTypographyProps={{ variant: "subtitle1", align: "center" }}
        sx={{ pb: 0 }}
      />
      <CardContent sx={{ flexGrow: 1, display: "flex" }}>
        <ToggleButtonGroup
          disabled={team === "referee"}
          color="primary"
          value={
            teamInterruptedGame && team !== "referee"
              ? "interrupting"
              : "nonInterrupting"
          }
          exclusive
          onChange={(event, value) => {
            setTeamInterruptedGame(value === "interrupting");
          }}
        >
          <ToggleButton value={"nonInterrupting"}>
            <Start />
            Nach dem Spielzug
          </ToggleButton>
          <ToggleButton value={"interrupting"}>
            <Bolt />
            Während des Spielzuges
          </ToggleButton>
        </ToggleButtonGroup>
      </CardContent>
    </Card>
  );
};

export default InterruptingChallengeSelector;
